module.exports = __webpack_public_path__ + "static/media/peugeot-go-drive.ecd5afcd.png";